import styled from "styled-components";

export const SectionHeading = styled.h3`
  margin: 0;
  align-self: flex-start;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const SectionDescription = styled.div`
  font-size: 1rem;
  margin-bottom: 0;
  text-align: left;
  width: 100%;
`;
export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--card-bg);
  padding: 1.5rem;
  border-radius: 1rem;
`;
